module.exports = __webpack_public_path__ + "img/coupon_15.0a7318a1.png";